import { render } from "./game-img-list.vue?vue&type=template&id=79aedce8&lang=pug"
import script from "./game-img-list.vue?vue&type=script&lang=js"
export * from "./game-img-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__